import { Formik, Form } from 'formik'

import { ModalWrapper } from 'src/components/modal-wrapper'
import { UnSdgForm } from '../un-sdg-form.component'
import { useCreateUnSdg } from 'src/hooks'
import { IUnSdgForm } from 'src/types'

import { useStyles } from '../styles'
import { unSdgSchema } from 'src/common/validations'

interface CreateUnSdgModalProps {
  open: boolean
  handleClose: () => void
}

const CreateUnSdgModal = ({ open, handleClose }: CreateUnSdgModalProps) => {
  const { mutateAsync: create } = useCreateUnSdg()
  const classes = useStyles()
  const handleSubmit = async (values: IUnSdgForm) => {
    await create({
      ...values,
      image: { file: values.image.file!, icon: values.image.icon },
    })
    handleClose()
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Formik
        initialValues={{
          description: '',
          name: '',
          more_info_url: '',
          image: { file: null, icon: '' },
        }}
        validationSchema={unSdgSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <UnSdgForm />
        </Form>
      </Formik>
    </ModalWrapper>
  )
}

export { CreateUnSdgModal }
